module.exports = __webpack_public_path__ + "img/people-faces-fs8.92d7b270.png";